angular.module('impactx.cscontract').controller('CSContractModelListForLotCtrl', [
    '$scope',
    '$redirect',
    '$controller',
    '$routeParams',
    'PartialDialogsService',
    CSContractModelListForLotCtrl]);

function CSContractModelListForLotCtrl($scope, $redirect, $controller, $routeParams, PartialDialogsService) {
    var mainCtrl = $controller('CSContractListCtrl', {});
    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.CONTRACT, 'cscontractmodellist/lot/'+($routeParams.lotId ? $routeParams.lotId : 0));
    mainCtrl.meta = {
        rowTemplate: 'modules/cscontract/templates/cscontractlist.row.tmpl.html',
        filtersTemplate: 'modules/cscontract/templates/cscontractlist.filters.tmpl.html',
        endpoint: '/cscontract/model/listforlot',
        ctrl: mainCtrl,
        id: "cscontractmodellistforlot",
        params: {'lotId': $routeParams.lotId ? $routeParams.lotId : 0},
        buttonDefinition: mainCtrl.buttonDefinition,
        excelParams: {
            params: [{param: 'LotId', intValue: $routeParams.lotId ? $routeParams.lotId : 0},
                {param: 'TenderId', intValue: 0}]
        },
        isSelectAble: true
    };
    this.getMeta = function () {
        return mainCtrl.meta;
    };
    mainCtrl.contractType = "model";
    $scope.$watch(function () {
        return mainCtrl.contractType;
    }, function (newValue) {
        if (newValue == "basic") {
            $redirect.redirectTo(null, "/cscontractlist/lot/" + $routeParams.lotId);
        }
    });
}